// export const firstColor = "#66127C";
export const firstColor = "#5B3FA5";
export const secondColor = "#F80601";
export const thirdColor = "#FFE77C";
export const lightGrey = "#B3B6B7";
export const darkGrey = "##1C1C1C";
export const linkColor = "#B93D1F";
